import React, {ReactElement} from 'react';
import logo from '../../assets/images/max logo.svg';
import backIcon from '../../assets/images/back.svg';
import {useHistory, useLocation} from 'react-router';
import {BackButtonAction} from '../../core/utils/string.util';
import {useAppDispatch} from '../../redux/hooks';
import {HOME_ROUTE_PATH, CHECKOUT_PATH} from '../../routes/route-constants';
import {resetState} from '../../redux/missingSizeApiSlice';
import {setShowGobackModal} from '../../redux/checkoutSlice';

type AppBarProps = {
  withDrawer?: boolean;
  centerContent?: React.ReactNode;
  showBackNav?: boolean;
  onDrawerClicked?: () => void;
  trailActions?: React.ReactNode;
  backButtonAction?: BackButtonAction | undefined;
  bgColor?: string;
};
const AppBar: React.FC<AppBarProps> = ({
  withDrawer = false,
  trailActions,
  onDrawerClicked,
  centerContent,
  showBackNav,
  backButtonAction = undefined,
  bgColor = '',
}: AppBarProps): ReactElement => {
  const dispatch = useAppDispatch();
  const navigate = useHistory();
  const location = useLocation();
  function handleBackClick(backButtonAction: BackButtonAction | undefined) {
    console.log(backButtonAction);
    switch (backButtonAction) {
      //case BackButtonAction.TO_MISSING_SIZE_HOME:
      // break;
      case BackButtonAction.GO_BACK:
        navigate.goBack();
        break;
      case BackButtonAction.TO_HOME:
        navigate.push(HOME_ROUTE_PATH);
        break;
      case BackButtonAction.TO_CHECKOUT_HOME:
        navigate.push(CHECKOUT_PATH);
        break;
      case BackButtonAction.TO_BARCODE_PAGE:
        dispatch(resetState());
        navigate.replace('/home/missingsizes');
        break;

      case BackButtonAction.TO_MISSING_SIZE:
        //console.log('in to missing size');
        navigate.replace('/home/selectsize');
        //add navigation.push
        //dispatch(setCurrentPage(MissingSizePage.SelectMissingSizePage));
        break;

      case BackButtonAction.BLOCK_NAVIGATION:
        dispatch(setShowGobackModal(true));
        break;

      case BackButtonAction.TO_RESETMISSING_SIZE:
        dispatch(resetState());
        navigate.push('/home/missingsizes');
        //dispatch(setCurrentPage(MissingSizePage.BarCodePage));
        break;
      default:
        navigate.goBack();
        break;
    }
  }
  return (
    <div
      className={`app-header grid grid-cols-4 gap-1 place-content-center p-4 h-16 ${
        bgColor !== '' ? bgColor : 'bg-blue_three'
      }`}>
      <div className="flex flex-wrap content-center leading col-span-1">
        {showBackNav ? (
          <a
            className="pr-3 pt-3 pb-3 pl-0 "
            onClick={() => handleBackClick(backButtonAction)}>
            <img src={backIcon} />
          </a>
        ) : (
          withDrawer &&
          (location.pathname === '/checkout/process_payment' ? null : (
            <a
              className="pr-3 pt-3 pb-3 pl-0"
              onClick={() =>
                onDrawerClicked
                  ? onDrawerClicked()
                  : console.log('not implemented')
              }>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </a>
          ))
        )}
      </div>
      <div className="flex flex-wrap place-content-center col-span-2 items-center">
        {centerContent || <img src={logo} alt="Buddy Logo" className="h-10" />}
      </div>

      {location.pathname === '/checkout/confirm' ||
      location.pathname === '/checkout/payment_error' ||
      location.pathname === '/checkout/process_payment' ? null : (
        <div className="grid content-center col-span-1">{trailActions}</div>
      )}
    </div>
  );
};
export default AppBar;
